export default class Locale_Reboot { 
	StartupStateAfterReboot: string = "Startup state after reboot";
	RebootButtonText: string = "Reboot";
	RebootAppService: string = "Reboot app service";
	RestartingApp: string = "Restarting app";
	RebootRequestSent: string = "A reboot request has been sent!";
	FailedRestartingAppService: string = "Failed restarting app service!";
}